export default "__VITE_ASSET__BSUVdy8T__"